import { render, staticRenderFns } from "./SubmittedNeedsModal.vue?vue&type=template&id=a2fcafe6&scoped=true&"
import script from "./SubmittedNeedsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmittedNeedsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fcafe6",
  null
  
)

export default component.exports